import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PanelItem } from '../../../../panels/panelItem';
import { useAppSelector } from '../../../../redux/store';
import { SIDE_BETS_PANEL_TEXT_VALUE_COLOR } from '../../../../styles/colors';
import { getCurrencyAmountString } from '../../../../utils/currencyUtils';
const POT_LABEL_CSS = css `
  color: white;
`;
const POT_VALUE_CSS = css `
  color: ${SIDE_BETS_PANEL_TEXT_VALUE_COLOR};
`;
export const SideBetPotPanelItemContainer = () => {
    const potTotal = useAppSelector((state) => state.sideBets.sideBetJacksPotTotal);
    if (!potTotal) {
        return null;
    }
    return (_jsxs(PanelItem, { flexWrap: true, typographyVariant: 'subtitle2', children: [_jsx("div", { css: POT_LABEL_CSS, children: "Pot" }), _jsx("div", { css: POT_VALUE_CSS, children: getCurrencyAmountString(potTotal, 'jacks') })] }));
};
